module.exports = ".aha-mobile-card-row{\n  border-bottom: 1px solid rgba(0,0,0,.175);\n}\n\n.aha-mobile-card-row:hover{\n  background-color: #f6f6f6;\n  cursor: pointer;\n}\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/search/mobile-search-results/mobile-search-results.component.css
// module id = ./src/app/search/mobile-search-results/mobile-search-results.component.css
// module chunks = main